import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Phone, Mail, MapPin, Clock } from "lucide-react";
import kitesLogo from "../assets/kites-logo.png";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#f9fcf3] via-white to-[#f7f9f2] border-t border-[#f0f7e1] mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-5">
            <div className="inline-block bg-gradient-to-r from-[#416200] to-[#334d00] rounded-2xl px-4 py-3 shadow-sm">
              <img src={kitesLogo} alt="Kites Fly - The Travel Companion" className="flight-anim h-9 md:h-10 w-auto" />
            </div>
          </div>
          <p className="text-sm text-slate-600 mb-4">Contact our Travel agent</p>
          <div className="space-y-2 text-sm text-slate-700">
            <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#70a308]" /> Available 24 x 7</div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#70a308]" /> +91 94963 13677</div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#70a308]" /> kitesflytravels@gmail.com</div>
          </div>
          <div className="flex items-center gap-3 mt-5">
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white border border-[#f0f7e1] flex items-center justify-center text-[#70a308] hover:bg-[#70a308] hover:text-white transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full bg-white border border-[#f0f7e1] flex items-center justify-center text-[#70a308] hover:bg-[#70a308] hover:text-white transition-colors"><Twitter className="w-4 h-4" /></a>
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white border border-[#f0f7e1] flex items-center justify-center text-[#70a308] hover:bg-[#70a308] hover:text-white transition-colors"><Instagram className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-lg font-bold text-slate-800 mb-4">Our Services</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/services" className="hover:text-[#5c8606]">Tour Packages</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Pilgrim Packages</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Passport Services</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Flight, Train &amp; Bus Tickets</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Visa Services</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Hotel Reservations</Link></li>
            <li><Link to="/services" className="hover:text-[#5c8606]">Travel Insurance</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-bold text-slate-800 mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/about" className="hover:text-[#5c8606]">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-[#5c8606]">Contact Us</Link></li>
            <li><a href="#" className="hover:text-[#5c8606]">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#5c8606]">Terms &amp; Condition</a></li>
            <li><a href="#" className="hover:text-[#5c8606]">Blog</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-bold text-slate-800 mb-4">Location</h4>
          <div className="flex items-start gap-2 text-sm text-slate-600 mb-4">
            <MapPin className="w-4 h-4 text-[#70a308] mt-0.5" />
            <div>
              Yamuna Arcade, Railway Station Link Road,<br />
              Palayam, Kozhikode, Kerala 673002
            </div>
          </div>
          <p className="text-sm text-slate-600">Subscribe to our newsletter for exclusive deals & travel inspiration.</p>
        </div>
      </div>
      <div className="border-t border-[#f0f7e1]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 text-sm text-slate-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <p>&copy; 2026 Kites Fly - The Travel Companion. All rights reserved.</p>
          <p>Crafted with care for wanderers</p>
        </div>
      </div>
    </footer>
  );
}
